import { Button, Stack, Typography, useTheme } from "@mui/material";
import { Lock, MessageCircle } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { IconBox } from "web_myplann/Shared/Components/IconBox";
import { MyPlannDrawer } from "web_myplann/Shared/Components/MyPlannDrawer";

type Props = {
	open: boolean;
	onClose: () => void;
	onMessageAdvisor: () => void;
};

export const GoalActionBlockedDrawer: FC<Props> = ({
	open,
	onClose,
	onMessageAdvisor,
}) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<MyPlannDrawer
			anchor="bottom"
			open={open}
			onClose={onClose}
			title={t(Resources.Goals.Detail.Blocked.title)}
			closeButton
		>
			<Stack px={2} pb={2.4} alignItems="center" textAlign="center">
				<IconBox bg={theme.palette.grey[200]} shape="circle" size={56} mb={1.4}>
					<Lock size={32} color={theme.palette.grey[400]} />
				</IconBox>
				<Typography variant="h3" mb={0.6}>
					{t(Resources.Goals.Detail.Blocked.heading)}
				</Typography>
				<Typography
					variant="body1"
					color={theme.palette.grey[600]}
					mb={2.4}
					lineHeight={"20px"}
				>
					{t(Resources.Goals.Detail.Blocked.description)}
				</Typography>
				<Button
					variant="primary"
					startIcon={<MessageCircle size={theme.iconSize.sm} />}
					onClick={onMessageAdvisor}
				>
					{t(Resources.Goals.Detail.Blocked.cta)}
				</Button>
			</Stack>
		</MyPlannDrawer>
	);
};
